import React from 'react';

interface MobileDrawHistoryEntryParameters {
    item: string;
    amount: string;
    topBorder?: boolean;
}

export const MobileDrawHistoryEntry: React.FC<MobileDrawHistoryEntryParameters> = ({ item, amount, topBorder = false }) => {
    return (
        <div className={`historyEntry${topBorder ? ' top-border' : ''}`}>
            <div className='historyEntry item'>{item}</div>
            <div className='historyEntry amount'>{amount}</div>
        </div>
    );
};
